import { FC } from 'react';
import { ITask } from 'store/tasks/tasksType';
import styled from 'styled-components';
import { green, lightBlue, lightGray, red } from 'utils/style/colors';
import { IDiagramTimestampRange, TimelinePoint } from './SmartSchedule';
import { withTitle } from 'components/withTitle';
import { smartDateDuration } from 'utils/date';

interface IScheduleDurationPointsProps {
  task: ITask;
  range: {
    right: number;
    width: number;
  } | null;
  diagramTimestampRange: IDiagramTimestampRange | undefined;
}

const PointInDiagramRatio = styled.div`
  position: absolute;
  ${(props) => `right:${props.ratio * 100}%`}
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) =>
    props.type === 'task-start'
      ? green
      : props.type === 'task-end'
        ? red
        : lightGray};
  z-index: ${(props) =>
    ['task-end', 'task-start'].includes(props.type) ? 5 : 4};
`;

const ScheduleDurationPoints: FC<IScheduleDurationPointsProps> = ({
  diagramTimestampRange,
  task,
  range,
}) => {
  const clamp = (v: number, min = 0, max = 1) =>
    Math.min(max, Math.max(min, v));

  const getTimelinePoints = (
    task: ITask,
    range: IDiagramTimestampRange
  ): TimelinePoint[] => {
    const baseStart = range.startTime;
    const baseEnd = range.dueTime;
    const baseDuration = baseEnd - baseStart;

    const points: TimelinePoint[] = [];

    points.push({
      ratio: 0,
      type: 'base-start',
    });

    if (typeof task.startDate === 'number') {
      points.push({
        ratio: clamp((task.startDate - baseStart) / baseDuration),
        type: 'task-start',
      });
    }

    if (typeof task.dueDate === 'number') {
      points.push({
        ratio: clamp((task.dueDate - baseStart) / baseDuration),
        type: 'task-end',
      });
    }

    points.push({
      ratio: 1,
      type: 'base-end',
    });

    return points.sort((a, b) => a.ratio - b.ratio);
  };

  return withTitle(
    <div
      style={{
        width: '100%',
        height: '1.1rem',
        // background: lightGray,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '0.1rem',
          background: lightGray,
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          top: '0.5rem',
        }}
      ></div>
      {diagramTimestampRange &&
        getTimelinePoints(task, diagramTimestampRange).map((p, i) => (
          <PointInDiagramRatio key={i} type={p.type} ratio={p.ratio} />
        ))}

      {range && (
        <div
          style={{
            position: 'absolute',
            right: `${range.right * 100}%`,
            width: `calc(${range.width * 100}% + 8px)`,
            height: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: lightBlue,
            borderRadius: '1rem',
            zIndex: 4,
          }}
        />
      )}
    </div>,
    smartDateDuration(task.startDate, task.dueDate, false, true, true),
    undefined,
    true
  );
};

export default ScheduleDurationPoints;
